import React, { FunctionComponent, RefObject, useState } from "react";
import { createPortal } from "react-dom";

import { SearchWheelsByVehiclePayload } from "../../../../queries/useSearchWheelsByVehicle";
import { LinearProgress } from "../../../../ui/LinearProgress";
import { ScrollControls } from "../../../ScrollControls/ScrollControls";
import { useHasOverflow } from "../../../ScrollControls/useHasOverflow";
import { TireSearchResults } from "../../../Tires/Results/useTireResults";
import { useVisualizerProductId } from "../../../Visualizer/useVisualizer";
import { ComboTileTire } from "./ComboTileTire";
import { ComboTileWheel } from "./ComboTileWheel";
import { PriceBox } from "./PriceBox";
import { ScrollBox } from "./ScrollBox";
import { useQuantity } from "./useQuantity";

export const Showcase: FunctionComponent<{
  portalRef?: RefObject<HTMLDivElement> | false;
  tires?: TireSearchResults | null;
  wheels?: SearchWheelsByVehiclePayload | null;
}> = ({ portalRef, tires, wheels }) => {
  const [selectedTireId, setSelectedTireId] = useState<null | string>(null);

  const [selectedWheelId, setSelectedWheelId] = useVisualizerProductId(
    wheels?.filteredParts || []
  );

  const [wheelRef, wheelScrollState] = useHasOverflow<HTMLDivElement>();
  const [tireRef, tireScrollState] = useHasOverflow<HTMLDivElement>();

  const selectedTire = tires?.filteredParts.find(
    (item) => item.partDetails.primaryPart.itemId === selectedTireId
  );

  const selectedWheel = wheels?.filteredParts.find(
    (item) => item.partDetails.primaryPart.itemId === selectedWheelId
  );

  const [quantity, setQuantity] = useQuantity(selectedTire, selectedWheel);

  if (!tires || !wheels) {
    return <LinearProgress className="my-8 h-0.5" />;
  }

  const priceBox = (
    <PriceBox
      isMd={!portalRef}
      quantity={quantity}
      setQuantity={setQuantity}
      tire={selectedTire}
      wheel={selectedWheel}
    />
  );

  return (
    <>
      <section className="py-1">
        <ScrollControls
          justifyBetween
          overflowState={wheelScrollState}
          scrollRef={wheelRef}
        />
        <div className="my-1 relative">
          <ScrollBox onPartSelect={setSelectedWheelId} ref={wheelRef}>
            {wheels.filteredParts.map((item) => (
              <ComboTileWheel
                key={item.partDetails.primaryPart.itemId}
                part={item}
                quantity={quantity}
              />
            ))}
          </ScrollBox>
          <div className="p-1" />
          <ScrollBox onPartSelect={setSelectedTireId} ref={tireRef}>
            {tires.filteredParts.map((item) => (
              <ComboTileTire
                key={item.partDetails.primaryPart.itemId}
                part={item}
                quantity={quantity}
              />
            ))}
          </ScrollBox>
          <div className="combo__frame md:combo__tile--md lg:combo__tile--lg" />
        </div>
        <ScrollControls
          justifyBetween
          overflowState={tireScrollState}
          scrollRef={tireRef}
        />
      </section>
      {portalRef ? createPortal(priceBox, portalRef.current!) : priceBox}
    </>
  );
};
